const isTest = typeof process !== 'undefined' && process.env && process.env.VITEST_WORKER_ID !== undefined;

function getRequiredEnv(key: string): string {
    const value = import.meta.env[key];
    if (!value && !isTest) {
        throw new Error(`Missing required environment variable: ${key}. Please ensure it is set during build time.`);
    }
    return value || '';
}

export const apiConfig = {
    useMocks: isTest ? true : import.meta.env.VITE_USE_MOCKS === 'true',
    baseUrl: getRequiredEnv('VITE_API_BASE_URL'),
    identityApiBaseUrl: getRequiredEnv('VITE_IDENTITY_API_BASE_URL'),
    loginRedirectUrl: getRequiredEnv('VITE_LOGIN_REDIRECT_URL'),
};
